<template>
    <Sidebar />
    <Content class="analytics-content">
        <div class="inner">
            <Navi />
        </div>
    </Content>
</template>

<script>
import Sidebar from '@/components/Sidebar.vue';
import Navi from '@/components/Navi.vue';
import Button from '@/components/ui/Button.vue';
import Content from '@/components/ui/Content.vue';
import SvgIcon from '@/components/ui/SvgIcon.vue';

export default {
    name: 'Analytics - Creator',

    data() {
        return {

        }
    },

    components: {
        Sidebar,
        Navi,
        Button,
        Content,
        SvgIcon,
    },

    methods: {

    },

}
</script>

<style lang="scss">
    .analytics-content {
    }
</style>